import { useField } from 'formik';
import { cloneElement, useMemo } from 'react';
import { FormField as FormField$1, FieldMessageType } from '@shipengine/giger';
import { jsx } from '@emotion/react/jsx-runtime';

const useFieldMessage = (fieldName, defaultMessage) => {
  const [, meta] = useField(fieldName);
  const formFieldMessage = useMemo(() => {
    if (meta.error && meta.touched) {
      return {
        type: FieldMessageType.ERROR,
        content: meta.error
      };
    } else if ((defaultMessage === null || defaultMessage === void 0 ? void 0 : defaultMessage.type) === FieldMessageType.HINT || (defaultMessage === null || defaultMessage === void 0 ? void 0 : defaultMessage.type) === FieldMessageType.INFO || (defaultMessage === null || defaultMessage === void 0 ? void 0 : defaultMessage.type) === FieldMessageType.SUCCESS) {
      return {
        type: defaultMessage.type,
        content: defaultMessage.content
      };
    }
    return undefined;
  }, [defaultMessage === null || defaultMessage === void 0 ? void 0 : defaultMessage.content, defaultMessage === null || defaultMessage === void 0 ? void 0 : defaultMessage.type, meta.error, meta.touched]);
  return formFieldMessage;
};
function FormField(_ref) {
  let {
    name,
    children,
    message,
    ...rest
  } = _ref;
  const formFieldMessage = useFieldMessage(name, message);
  return jsx(FormField$1, {
    message: formFieldMessage,
    ...rest,
    children: /*#__PURE__*/cloneElement(children, {
      name
    })
  });
}
FormField.displayName = 'FormikFormField';

export { FormField };
//# sourceMappingURL=FormField.js.map
